import axios from 'axios';

export default class AuthService {
  login(form) {
    return axios.post('/login', form).then(response => {
      return response.data;
    });
  }
  loginAs(form) {
    return axios.post('/login-as', form).then(response => {
      return response.data;
    });
  }

  logout() {
    // check if the token is present
    if (axios.defaults.headers.common['Authorization']) {
      return axios.post('/logout');
    } else {
      // already signed out, just tell the caller we are done
      console.log('already signed out, not doing backend request');
      return Promise.resolve();
    }
  }

  refreshToken() {
    return axios.get('/auth/refresh').then(response => {
      if (response.status == 401 && response.data.token == null) {
        // cannot be refreshed anymore
        return Promise.reject('Refresh failed');
      }

      return response.data.token;
    });
  }
}
